export default __webpack_public_path__ + "static/media/home-hotel-section.0c9f3d9f.webp";